var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-container",class:{'is-active':_vm.isCollapse}},[_c('el-menu',{attrs:{"unique-opened":"","default-active":_vm.nowTagValue,"mode":"vertical","show-timeout":200,"background-color":"#fff","text-color":"#666","collapse":_vm.isCollapse}},[_c('sidebar-item',{attrs:{"menu":_vm.menu,"isCollapse":_vm.isCollapse}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }